<template>
  <div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 ">
    <loading v-if="loading" />
    <div class="container  mb-5">

      <div class="row justify-content-center">
        <div class="col-md-12 center ">
          <h3 class="Bold center pb-4 mt-5 subtitle fancy widthFull"><strong>Reimposta Password</strong></h3>
        </div>
      </div>

			<div class="row justify-content-center verticalCentred vaillantCont">

					<div class="col-sm-9 col-md-5 pt-4 ">

					<div class="container-fluid">
						<form class="recovery-password  pb-4" id="recovery-form" @submit.prevent="recovery">

							<div v-if="!state" >
								<div class="form-row justify-content-center">
									<div class="col-md-12">

										<div class="group custInput mt-5" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
											<input type="password" v-model="password" class="form-control mt-1"  id="password" name="password" v-validate="{required:true, passwordCheck: true, min: 8, max: 56}" :class="{ 'is-invalid': errors.has('password'), valid: !!password }">
											<span class="highlight"></span>
											<span class="bar"></span>
											<label class="niceInputLabel" for="password">Nuova Password</label>

											<div v-if="errors.has('password')" class="invalid-feedback">
												{{ errors.first("password") }}
											</div>
										</div>
										<div class="group custInput mt-5" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
											<input type="password" v-model="confirm_password" class="form-control mt-3"  id="confirm_password" name="confirm_password" data-vv-as="conferma password" v-validate="{required:true, passwordCheck: true, min: 8, max: 56}" :class="{ 'is-invalid': errors.has('confirm_password'), valid: !!confirm_password }">
											<span class="highlight"></span>
											<span class="bar"></span>
											<label class="niceInputLabel" for="password">Conferma Nuova Password</label>

											<div v-if="errors.has('confirm_password')" class="invalid-feedback">
												{{ errors.first("confirm_password") }}
											</div>
											<div v-if="error" class="mt-3">
												<span class="formError ml-1">{{error}}</span>
											</div>
										</div>
									</div>
								</div>
								<div class="form-row justify-content-center">
									<div class="col-md-12 mb-3 mt-5 text-center">
										<button class="btn btn-primary  btn-lg" :class="{'btnHSDRed': brand == 'HAPPYBONUS' }" type="submit">CONFERMA</button>
									</div>
								</div>
							</div>
							<div v-else="!state">
								<div class="form-row justify-content-center">
									<div class="col-md-12 mb-5 mt-5">
										<h5 for="email" class="center widthFull" role="alert">
											<p class="black">La password è stata aggiornata correttamente,</p>
											<p  class="black">adesso puoi accedere utilizzando la tua nuova password..</p>

										</h5>
									</div>
								</div>
								<div class="form-row justify-content-center">
									<div class="col-md-12 mb-3 text-center">
										<router-link class="btn btn-primary btn-lg" :class="{'btnHSDRed': brand == 'HAPPYBONUS' }" to="/login">Accedi</router-link>
									</div>
								</div>
							</div>

						</form>
					</div>
				</div>
			</div>

		</div>

	</div>

</template>

<script>
  import {AUTH_REQUEST} from 'actions/auth'
  import { mapGetters, mapState } from 'vuex'
  import axios from 'axios'

  export default {
    name: 'recoverypassword',
		components: {

		},
    data () {
      return {
        password: '',
		    confirm_password: '',
		    state: false,
		    error: '',
		    loading: false,
        brand: process.env.BRAND,
      }
    },
    methods: {
      recovery: function () {
        const { password, confirm_password } = this
				const token = this.$route.query.token

				this.$validator.validate().then(valid => {
					if (valid && token) {
						this.loading = true
						axios({
							url: process.env.ROOT_API + 'fapi/change_password',
							data: {
								password: password,
								token: token
							},
							method: 'POST',
							headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
						.then(resp => {
							this.state = true
							this.loading = false
						})
						.catch(resp => {
							this.state = false;
							this.error = process.env.TOKEN_NOT_EXIST
							this.loading = false
						})
					}
				})
      }
    },
	computed: {
      ...mapGetters(['getProfile', 'loginerror', 'loadingState', 'isAuthenticated', 'isProfileLoaded']),
      ...mapState({
        //login_error: state => `${state.login_error}`,
      })
    },
  }

</script>



// WEBPACK FOOTER //
// src/components/recoverypassword/index.vue